<template>
    <div class="text-center">
      <v-btn    
                :background-color="$store.getters.getColorPalette().background1ColorCode"
                :color="$store.getters.getColorPalette().accent"
                small 
                text
                :dark="$store.getters.getColorPalette().isDark"
                outlined
                @click="dialog=!dialog" >
                {{$store.getters.getTextMap().create_issue_voucher}} 
          <v-icon small>mdi-plus</v-icon>
        </v-btn>
      
  <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
      <v-card  :dark="$store.getters.getColorPalette().isDark"  :color="$store.getters.getColorPalette().background2ColorCode">
      <v-toolbar
          :dark="$store.getters.getColorPalette().isDark"
            :color="$store.getters.getColorPalette().foregroundColorCode"
          >
            <v-btn
              icon
             :dark="$store.getters.getColorPalette().isDark" 
              @click="dialog = false"
            >
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>{{ $store.getters.getTextMap().create_issue_voucher }}</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn
               :dark="$store.getters.getColorPalette().isDark" 
                text
                @click="dialog = false"
              >
              {{ $store.getters.getTextMap().close }}
              </v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-container>
            <v-row >
              <v-col cols="12">
                <CreateIssueVoucher v-on:close="dialog=false" />
              </v-col>
            

            </v-row>
          </v-container>
      </v-card>
  </v-dialog>
    </div>
  </template>
  <script>
import CreateIssueVoucher from '@/components/crud_components/manufacturing/stores/CreateIssueVoucher';
//   import AddGaugeToDashboard from '@/components/crud_components/AddGaugeToDashboard'
//   import AddParamToDashboard from '@/components/crud_components/AddParamToDashboard'
//   import AddMachineToDashboard from '@/components/crud_components/AddMachineToDashboard'
  
  export default {
      name:'CreateIssueVoucherBottomSheet',
      components:{
          CreateIssueVoucher,
        //   AddGaugeToDashboard,
        //   AddParamToDashboard,
        //   AddMachineToDashboard
      },
      data(){
          return {
              dialog:false,
              
            //   objectRules:[
            //     v => !!v || this.$store.getters.getTextMap().required,
            //   ],
        }
      },
      
  }
  </script>
  